export default "__VITE_ASSET__ef8844c4__"